import React, { useState, useEffect, useCallback } from 'react';
import { X, DollarSign, Zap, Shield, Truck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ExitIntentPopup = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const handleMouseLeave = useCallback((e) => {
    if (e.clientY <= 5 && !sessionStorage.getItem('exitPopupShown')) {
      setShow(true);
      sessionStorage.setItem('exitPopupShown', 'true');
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [handleMouseLeave]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="exit-intent-popup">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setShow(false)} />
      <div className="relative bg-slate-900 border border-slate-700 rounded-2xl max-w-md w-full p-8 shadow-2xl shadow-green-500/10">
        <button
          onClick={() => setShow(false)}
          className="absolute top-4 right-4 text-slate-400 hover:text-white"
          data-testid="exit-popup-close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center">
          <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <DollarSign className="w-8 h-8 text-green-500" />
          </div>
          <h3 className="text-2xl font-bold text-white mb-2">
            Wait! Get Your Free Quote
          </h3>
          <p className="text-slate-400 mb-6">
            Find out how much your device is worth in just 30 seconds. No obligation, no hassle.
          </p>

          <button
            onClick={() => { setShow(false); navigate('/sell'); }}
            className="w-full bg-green-600 hover:bg-green-500 text-white font-bold py-4 rounded-xl mb-4 transition-colors"
            data-testid="exit-popup-cta"
          >
            Get My Instant Quote
          </button>

          <div className="flex justify-center gap-4 text-xs text-slate-400">
            <span className="flex items-center gap-1"><Zap className="w-3 h-3 text-yellow-500" /> Instant</span>
            <span className="flex items-center gap-1"><Truck className="w-3 h-3 text-blue-500" /> Free Ship</span>
            <span className="flex items-center gap-1"><Shield className="w-3 h-3 text-purple-500" /> Price Match</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitIntentPopup;
